<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 text-center">
    <div *ngIf="!guardando">
      <p-pickList [source]="actFuente" [target]="actSeleccionadas"
                  sourceHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESDISPONIBLES'|translate}}"
                  targetHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESSELECCIONADAS'|translate}}"
                  (onMoveToTarget)="guardar($event.items, true)"
                  (onMoveToSource)="guardar($event.items, false)"
                  [showTargetControls]="false"
                  [showSourceControls]="false"
                  filterBy="actividadEconomica">
        <ng-template let-actividad pTemplate="item">
          <div class="p-helper-clearfix">
            {{actividad.codigoActividadEconomica}}-{{actividad.actividadEconomica}}
          </div>
        </ng-template>
      </p-pickList>
    </div>
    <div *ngIf="guardando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </div>
  </div>
</div>
<p-confirmDialog #cd key="garantia-idoneas-destinos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

